import { useId } from 'react'
import { Box, Paper, Table, TableContainer } from '@mui/material'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import SearchRow from '@/components/SecondaryLeftNavigation/components/SearchRow'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import { USERS_ROW_MENU_ITEMS } from '@/components/Settings/settingsTablePlaceholders'
import shared from '@/components/Settings/settingsShared.module.scss'
import UsersTableBody from '@/components/Settings/SettingsPageContent/UsersTableBody'
import UsersTableHead from '@/components/Settings/SettingsPageContent/UsersTableHead'
import { useUsersTableModel } from '@/components/Settings/SettingsPageContent/useUsersTableModel'

export default function UsersTable() {
  const m = useUsersTableModel()
  const headingId = useId()
  const intro = getSettingsSectionIntro('users-directory')
  return (
    <Box component="section" aria-labelledby={headingId} className={shared.usersSection}>
      {intro ? <SettingsSectionIntro headingId={headingId} lines={intro} /> : null}
      <Box className={shared.searchRowWrap}>
        <SearchRow value={m.userQuery} onChange={m.setUserQuery} placeholder="Search users, roles" />
      </Box>
      <TableContainer component={Paper} elevation={0} className={shared.tableContainerPaper}>
        <Box className={shared.tableInnerClip}>
          <Table size="small" className={shared.tableRoot}>
            <UsersTableHead />
            <UsersTableBody rows={m.filteredUsers} openMenu={m.openMenu} menuUserId={m.menuUserId} onOpenMenu={m.handleOpenMenu} />
          </Table>
        </Box>
      </TableContainer>
      <FloatingMenuPopup
        open={m.openMenu}
        anchorEl={m.menuAnchor}
        onClose={m.handleCloseMenu}
        items={USERS_ROW_MENU_ITEMS}
        onItemSelect={() => {}}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        menuListId="users-row-actions-menu"
        menuListAriaLabel="User row actions"
      />
    </Box>
  )
}
